import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation, clientQuery } from "../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../core/logManager";
import { resetALL } from "../../../../../.globals/redux/actions";

const INIT_STATE = {
    open: false,
    loading: false,
    result: [],
    nextToken: null,
    transactionId: null
};

const route = "modules/.common/components/TransactionsSummary/redux/slice";

export const transactionsSummarySearchTransactions = createAsyncThunk("transactionsSummary/searchTransactions", async (payload, { rejectWithValue }) => {
    try {
        const { transactionId, nextToken } = payload
        const response = await clientQuery(
            `
                query searchTransactions ($transactionId: String!, $nextToken: String) {
                    data: searchTransactions (transactionId: $transactionId, nextToken: $nextToken) {
                        items {
                            Id
                            TransactionId
                            Type
                            State
                            ErrorMessage
                            NewId
                            Data
                            CreatedBy
                            CreatedOn
                            ProcessedOn
                        }
                        nextToken
                    }
                }
            `,
            {
                transactionId,
                nextToken
            },
            endpoints.GRAPHQL_GENERAL
        );

        return response?.data

    } catch (exc) {
        ExceptionManager(exc, route, "searchTransactions");
        return rejectWithValue(exc);
    }
}
);


const transactionsSummaryRedux = createSlice({
    name: "transactionsSummary/Summary",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload
                ? { ...state, ...action.payload }
                : { ...INIT_STATE };
        },
        openModalTransactionsSummary(state, action) {
            state.open = true;
            state.transactionId = action.payload.transactionId
        },
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //transactionsSummarySearchTransactions
        builder.addCase(transactionsSummarySearchTransactions.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(transactionsSummarySearchTransactions.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action.payload.items;
            state.nextToken = action.payload.nextToken;
        });
        builder.addCase(transactionsSummarySearchTransactions.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = transactionsSummaryRedux;

// Extract and export each action creator by name
export const { reset, openModalTransactionsSummary } = actions;

// Export the reducer, either as a default or named export
export default reducer;